import React from "react";

// Consort signet — a lowercase "c" ring crowned by a faceted solitaire diamond.
// Uses currentColor so `text-primary` tints it gold.
export default function ConsortMark({ size = 24, className = "", strokeWidth = 1.6, ...props }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}
      stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true" data-testid="consort-mark" {...props}>
      {/* solitaire diamond resting on the crest */}
      <path d="M12 1.6 L15.4 4.7 L12 8 L8.6 4.7 Z" fill="currentColor" stroke="none" />
      {/* subtle facets */}
      <g stroke="#000" strokeOpacity="0.18" strokeWidth="0.5" strokeLinecap="butt">
        <path d="M8.6 4.7 H15.4" />
        <path d="M12 1.6 L10.4 4.7 L12 8" />
        <path d="M12 1.6 L13.6 4.7 L12 8" />
      </g>
      {/* lowercase 'c' ring, opening to the right */}
      <path d="M15.5 9 A6.6 6.6 0 1 0 15.5 19.6" fill="none" />
    </svg>
  );
}
